import axios from 'axios';
import { CUSTOM_ORDER_SOURCE } from '../../../../common/customOrder/constants';

export const buildCustomOrderProps = async({ sellerUsername, gigSlug, pathfinderWrapper, logger }) => {
    const uploadOptions = {
        objectName: 'message',
        getPolicyUrl: pathfinderWrapper.pathfinder('messages_attachments_policy'),
        createPendingAttachmentIdUrl: pathfinderWrapper.pathfinder('messages_create_pending_attachment')
    };

    const baseProps = {
        gigSlug,
        source: CUSTOM_ORDER_SOURCE,
        onSubmitSuccess: () => true,
        submitPath: pathfinderWrapper.pathfinder('create_custom_order_request'),
        uploadOptions
    };

    const [customOrderData, userOnlineStatus] = await Promise.all([
        getCustomOrderData({ sellerUsername, gigSlug, pathfinderWrapper, logger }),
        getUserOnlineStatus({ username: sellerUsername, pathfinderWrapper, logger })
    ]);

    return {
        ...baseProps,
        ...customOrderData.data,
        isOnline: userOnlineStatus.is_online
    };
};

export const getCustomOrderData = async({ sellerUsername, gigSlug, pathfinderWrapper, logger }) => {
    const url = pathfinderWrapper.pathfinder('new_custom_order_request_form', { seller: sellerUsername, gig: gigSlug });

    try {
        const { data } = await axios.get(url);
        return data;
    } catch (err) {
        logger.error(err);

        throw err;
    }
};

export const getUserOnlineStatus = async({ username, pathfinderWrapper, logger }) => {
    const url = pathfinderWrapper.pathfinder('is_online', { username });

    try {
        const { data } = await axios.get(url);
        return data;
    } catch (err) {
        logger.error(err);

        return { is_online: false };
    }
};
